import React, { Component } from 'react';
import Topbar from '../components/Topbar';
import {
  Button,
  ButtonGroup,
  Container,
  CssBaseline,
  Grid,
  // Icon,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  withStyles,
  Typography,
} from '@material-ui/core';

import { ATTEND_TB, EVENT_ID, EVENT_IMG, EVENTS_API_URL, getUserID, minuteToFormat, USER_API_URL, SURVEY_API_URL } from '../constants';
import axios from 'axios';
import MainContext from '../MainContext';
import PrizeEventDialog from '../components/dialogs/PrizeEventDialog';

// 세션별 시간 표시

const SESSION_TITLE = [
  { num: 0, strT: '08:40', name: 'Session 1', totalTime: '08:40 - 10:20', firstTime: '08:40 - 09:25 ', secondTime: '09:35 - 10:20' },
  { num: 1, strT: '10:30', name: 'Session 2', totalTime: '10:30 - 12:10', firstTime: '10:30 - 11:15 ', secondTime: '11:25 - 12:10' },
  { num: 2, strT: '12:20', name: '산학세션', totalTime: '12:20 - 13:00' },
  { num: 3, strT: '13:10', name: '산학세션', totalTime: '13:10 - 13:50' },
  { num: 4, strT: '14:00', name: 'Session 3', totalTime: '14:00 - 15:40', firstTime: '14:00 - 14:45', secondTime: '14:55 - 15:40' },
  { num: 5, strT: '15:50', name: 'Session 4', totalTime: '15:50 - 17:30', firstTime: '15:50 - 16:35', secondTime: '16:45 - 17:30' },

  { num: 0, strT: '08:00', name: 'Session 1', totalTime: '08:00 - 09:40', firstTime: '08:00 - 08:45', secondTime: '08:55 - 09:40' },
  { num: 1, strT: '09:50', name: 'Session 2', totalTime: '09:50 - 11:30', firstTime: '09:50 - 10:35', secondTime: '10:45 - 11:30' },
  { num: 2, strT: '11:40', name: '산학세션', totalTime: '11:40 - 12:20' },
  { num: 3, strT: '12:30', name: 'Session 3', totalTime: '12:30 - 13:15' },
  { num: 4, strT: '13:20', name: 'Session 4', totalTime: '13:20 - 14:50', firstTime: '13:20 - 14:00', secondTime: '14:10 - 14:50' },
  { num: 5, strT: '15:00', name: 'Session 5', totalTime: '15:00 - 16:30' },
  { num: 6, strT: '16:40', name: 'Session 6', totalTime: '16:40 - 18:10' },
];

const moment = require('moment');

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabBtnGroup: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: 20,
    },
  },
  tableWeb: {
    marginTop: '20px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  tableMob: {
    width: '100%', //'280px'
    marginBottom: '15px',
    fontSize: '14px',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

  tableCell: {
    textAlign: 'center',
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#47ac88',
    color: theme.palette.common.white,
    textAlign: 'center',
    // fontWeight: 'bold',
    fontSize: 'large',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  body: {
    fontSize: 'large',
    color: '#000000',
    textAlign: 'center',
    '&:first-child': {
      backgroundColor: '#fafafa',
      // fontWeight: 'bold',
    },
  },
  root: {},
}))(TableCell);

class MyPage extends Component {
  static contextType = MainContext;
  constructor(props) {
    super(props);

    this.state = {
      arrDate: [],
      total: 0,
      selectIdx: 0,
      myInfo: '',
      matches: window.matchMedia('(max-width:600px)').matches,
      openPrizeEventDialog1: false,
      openPrizeEventDialog2: false,
      openPrizeEventDialog3: false,
      eventUrl1: '',
      eventUrl2: '',
      eventUrl3: '',
      arrQuiz: [],
    };
  }

  componentWillUnmount() {
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:600px)').removeListener(handler);
  }
  componentDidMount() {
    if (!sessionStorage.getItem('_in_user_')) {
      this.props.history.push('signin');
      return;
    }
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:600px)').addListener(handler);
    try {
      axios.get(`${USER_API_URL}/user/info?eventId=${EVENT_ID}&userId=${getUserID()}`, { headers: { Pragma: 'no-cache' } }).then((res) => {
        this.setState({ myInfo: res.data.Item });
        this.getDateProgram(this.context.dayIndex);
        // console.log(this.state.myInfo, '사용자 정보');
      });

      axios.get(`${SURVEY_API_URL}/polls/?eventId=${EVENT_ID}&channel=Channel01`, { headers: { Pragma: 'no-cache' } }).then((res) => {
        res.data.Items.sort((a, b) => {
          return a.orderNo - b.orderNo;
        });
        this.setState({ arrQuiz: res.data.Items });
      });
    } catch (e) {
      console.error(e);
    }
  }
  getDateProgram(idx) {
    console.log('idx', idx);

    let _date = new Date();
    let item = JSON.parse(sessionStorage.getItem('Item'));
    if (this.context.arrDate && this.context.arrDate[idx]) _date = moment(this.context.arrDate[idx]).format('YYYYMMDD');
    else _date = moment(item.startDate).format('YYYYMMDD');

    this.setState({ selectIdx: idx, selectDate: _date, sessionData: null, btnIdx: idx });

    axios
      .get(`${EVENTS_API_URL}/event/pgmByDate?eventId=${EVENT_ID}&date=${_date}`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        // console.log(response.data.Items);

        let res = response.data.Items.sort((a, b) => {
          return a.startTime > b.startTime ? 1 : -1;
        });

        const mapItem = new Map();
        // eslint-disable-next-line
        res.map((data) => {
          if (!data.isBreak) {
            if (mapItem.has(data.session)) {
              this.setState({ total: 0, [`${data.session}_IN`]: '', [`${data.session}_OUT`]: '', [`${data.session}_TS`]: '' });
            } else {
              mapItem.set(data.session, {
                sessionNo: data.session,
                startTime: data.startTime,
                endTime: data.endTime,
              });
              this.setState({ total: 0, [`${data.session}_IN`]: '', [`${data.session}_OUT`]: '', [`${data.session}_TS`]: '' });
            }
          }
        });

        this.setState({ sessionTimes: Array.from(mapItem), sessionData: res }, () => {
          // console.log('sessionTimes', this.state.sessionTimes);
          // console.log('sessionData', this.state.sessionData);
        });
        this.getData(_date);
      });
  }

  getData(etDate) {
    console.log(this.state.myInfo);
    axios
      .get(`${USER_API_URL}/user/attend/?userid=${getUserID()}&evt=${EVENT_ID}&tbName=${ATTEND_TB}&etDate=${etDate}`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((res) => {
        // const sessionTime = this.state.sessionTimes[_tab];
        if (res.data.Item) {
          for (const [key, value] of Object.entries(res.data.Item)) {
            const check = key.split('_');
            const type = key.replace(`${check[0]}_`, '');
            if (type === 'IN_ST') {
              this.setState({ [check[0] + '_IN']: value });
            }
            if (type === 'OUT_ST') {
              this.setState({ [check[0] + '_OUT']: value });
            }
            if (type === 'TS') {
              if (value.indexOf('NaN') === -1) this.setState({ [check[0] + '_TS']: value });
            }
            if (type === 'TM') {
              this.setState({ total: this.state.total + Number(value) });
            }
          }
        }
        if (
          !this.state.myInfo?.country ||
          !!this.state.myInfo?.country?.length < 1 ||
          !!this.state.myInfo?.userType === '산학업체(무료)' ||
          !!this.state.myInfo?.userType === '전시업체(무료)'
        )
          this.checkEvent();
      });
  }

  getDateButton = () => {
    return this.context.arrDate.map((data, idx) => {
      const val = moment(data).format('YYYYMMDD');
      return (
        <Button
          key={idx}
          className={this.props.classes.dateButton}
          onClick={() => {
            this.getDateProgram(idx);
          }}
          variant={this.state.selectDate === val ? 'contained' : 'outlined'}
          style={{ textTransform: 'none', fontSize: this.state.matches ? 'small' : 'large' }}
        >
          {moment(data).format('MMMM DD (ddd.)')}
        </Button>
      );
    });
  };

  getSessionTotal = (sessionNo) => {
    console.log(this.state[`${sessionNo}_TS`]);
    return this.state[`${sessionNo}_TS`].split(':');
  };

  checkEvent = () => {
    console.log('checkEvent >>>>');
    console.log('myInfo', this.state.myInfo);
    // eslint-disable-next-line
    let item = JSON.parse(sessionStorage.getItem('Item'));
    const today = moment().format('YYYYMMDD');
    let idx = this.context.arrDate.findIndex((d) => moment(d).format('YYYYMMDD') === today);

    // console.log('myInfo', this.state.myInfo);

    const URL_LIVE = 'https://m.touchevent.net/e/y0LO9t';

    if (this.state.selectDate !== today) {
      return;
    }

    const todayTime = moment().format('HHmm');
    if (idx === 0) {
      // ----- 1일 -----
      const event_30min_start = moment('1220', 'HHmm').format('HHmm');
      const event_30min_end = moment('1450', 'HHmm').format('HHmm'); // 산학세션 종료 후 1시간

      const session3 = this.getSessionTotal(3);
      const session4 = this.getSessionTotal(4);

      let checkSum = 0; // 수강시간
      if (session3 && session3.length > 1) checkSum += Number(session3[1]);
      if (session4 && session4.length > 1) checkSum += Number(session4[1]);
      console.log('event::', checkSum);

      if (checkSum >= 30) {
        if (todayTime >= event_30min_start && todayTime <= event_30min_end) {
          console.log(
            '1일차 산학세션 30분 이상 수강',
            // localStorage.getItem(`${today}_live_checked`) && !(this.state.myInfo && this.state.myInfo[`${today}_live_checked`]),
          );
          this.setState({
            eventUrl1: URL_LIVE,
            openPrizeEventDialog1:
              !localStorage.getItem(`${today}_live_checked`) && !(this.state.myInfo && this.state.myInfo[`${today}_live_checked`]),
            // true,
          });
        }
      }
    } else {
      // ----- 2일 -----
      const event_30min_start = moment('1140', 'HHmm').format('HHmm');
      const event_30min_end = moment('1320', 'HHmm').format('HHmm');
      const session3 = this.getSessionTotal(3);
      const evtUrl =
        this.state.myInfo.cate2?.length > 1 || this.state.myInfo.amount?.length > 1
          ? 'https://m.touchevent.net/e/UA4njd'
          : 'https://m.touchevent.net/e/y0LO9t';
      console.log(evtUrl, 'evturl');
      // 2일차 산학세션 체크
      if (session3 && session3.length > 1 && session3[1] >= 30) {
        if (todayTime >= event_30min_start && todayTime <= event_30min_end) {
          console.log(
            '2일차 산학세션 30분 이상 수강',
            // localStorage.getItem(`${today}_live_checked`) && !(this.state.myInfo && this.state.myInfo[`${today}_live_checked`]),
          );
          this.setState({
            eventUrl1: evtUrl,
            openPrizeEventDialog1:
              !localStorage.getItem(`${today}_live_checked`) && !(this.state.myInfo && this.state.myInfo[`${today}_live_checked`]),
            // true,
          });
        }
      }
    }
  };

  //참석확인증 다운로드
  handleClickOpen = () => {
    console.log(this.state.myInfo);
    const nm = this.state.myInfo.in_name_en ? this.state.myInfo.in_name_en : this.state.myInfo.username;
    const pos = this.state.myInfo.positionEn ? this.state.myInfo.positionEn : this.state.position;
    window.open(`/#/mypage/print?name=${nm}&position=${encodeURIComponent(pos)}`, '_blank', 'width=800, height=600');
  };

  getSessionTitle = (num, strT) => {
    return SESSION_TITLE.filter((dt) => dt.num === num && dt.strT === strT).map((sessionDatas, idx) => {
      return (
        <Grid container key={idx}>
          <Grid item xs={12}>
            {sessionDatas.totalTime}
            {/* [{sessionDatas.name}]&nbsp;{sessionDatas.totalTime} */}
          </Grid>
          {/* {sessionDatas.firstTime && sessionDatas.secondTime && (
            <Grid item xs={12} style={{ fontSize: 'small' }}>
              (&nbsp;{sessionDatas.firstTime}&nbsp;||&nbsp;{sessionDatas.secondTime}&nbsp;)
            </Grid>
          )} */}
        </Grid>
      );
    });
  };

  render() {
    const { classes } = this.props;
    const currentPath = this.props.location ? this.props.location.pathname : '/live';

    return (
      <React.Fragment>
        <CssBaseline />
        {currentPath !== '/live' && <Topbar currentPath={currentPath} />}

        <div style={{ height: currentPath !== '/live' && 'calc(100% - 84px)', overflowY: 'auto' }}>
          <Container spacing={1} style={{ height: '100%' }}>
            {currentPath !== '/live' && (
              <h2
                style={
                  this.state.matches
                    ? { color: this.props.theme.palette.primary.main, fontWeight: 'bold', fontSize: '26px', textAlign: 'center' }
                    : {
                        color: this.props.theme.palette.primary.main,
                        fontWeight: 'bold',
                        fontSize: '30px',
                        paddingTop: this.state.matches ? '2vh' : '6vh',
                      }
                }
              >
                {/* 출결 확인 */}
                평점확인(Only Korean)
              </h2>
            )}
            <div style={{ color: '#010101', lineHeight: 2, paddingBottom: '15px' }}>
              <b style={{ fontSize: '24px', color: this.props.theme.palette.primary.main }}>대한의사협회 평점확인</b>
              <br />
              <span style={{ color: '#555555', fontSize: this.state.matches ? '0.95rem' : '18px', lineHeight: 1 }}>
                ※ 입/퇴장 시간이 반영되는데 몇 분 소요될 수 있습니다.
              </span>
              <br />
            </div>

            {/* {currentPath !== '/live' && (
              <Grid container>
                <Grid container alignContent="center" justifyContent={this.state.matches ? 'center' : 'flex-start'}>
                  <Button
                    size={'small'}
                    color={'primary'}
                    variant={'outlined'}
                    disableElevation
                    startIcon={<Icon>print</Icon>}
                    onClick={() => this.handleClickOpen()}
                    style={{ padding: this.state.matches ? '1vh 2vw' : '1vh 1vw', fontWeight: 'bold', marginBottom: '15px' }}
                  >
                    Certificate of Attendance Download
                  </Button>
                </Grid>
              </Grid>
            )} */}
            <ButtonGroup
              color="primary"
              disableElevation
              aria-label="outlined primary button group"
              fullWidth
              className={classes.tabBtnGroup}
            >
              {this.context.arrDate && this.context.arrDate.length > 0 ? this.getDateButton() : null}
            </ButtonGroup>

            <TableContainer className={classes.tableWeb}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell style={{ borderRight: '1px solid #ffffff' }} width="25%">
                      구분
                    </StyledTableCell>
                    <StyledTableCell style={{ borderRight: '1px solid #ffffff' }} width="25%">
                      입장
                    </StyledTableCell>
                    <StyledTableCell style={{ borderRight: '1px solid #ffffff' }} width="25%">
                      퇴장
                    </StyledTableCell>
                    <StyledTableCell width="25%">인정시간</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.sessionTimes &&
                    this.state.sessionTimes.map((row, idx) => (
                      <TableRow key={row[1].startTime}>
                        <StyledTableCell component="th" scope="row" align="center">
                          {/* * KSC2022 CUSTOM:: 분리된 세션 기준 없음 -> 세션별로 직접 표기  */}

                          {this.getSessionTitle(idx, row[1].startTime)}
                          {/* {idx === 0 && row[1].startTime === '08:40' && '세션 1'} */}

                          {/* {'Session ' + (idx + 1) + ' (' + row[1].startTime + '-' + row[1].endTime + ')'}12345 */}
                        </StyledTableCell>
                        <StyledTableCell align="center">{this.state[row[1].sessionNo + '_IN']}</StyledTableCell>
                        <StyledTableCell align="center">{this.state[row[1].sessionNo + '_OUT']}</StyledTableCell>
                        <StyledTableCell align="center">{this.state[row[1].sessionNo + '_TS']}</StyledTableCell>
                      </TableRow>
                    ))}

                  <TableRow>
                    <StyledTableCell align="center">총 인정시간</StyledTableCell>
                    <StyledTableCell colSpan={3} align="center">
                      {minuteToFormat(this.state.total)}
                    </StyledTableCell>
                  </TableRow>
                  {/* <TableRow>
                    <StyledTableCell align="center">의사협회 평점</StyledTableCell>

                    <StyledTableCell colSpan={3} align="center">
                      {Math.floor(this.state.total / 60) > 6 ? 6 : Math.floor(this.state.total / 60)}
                      <span>{this.state.req_score ? `( 필수평점 : ${this.state.req_score} )` : ''}</span>
                    </StyledTableCell>
                  </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>
            {/* 모바일용 표 */}
            <div style={currentPath === '/live' ? { width: '100%' } : { paddingBottom: '30px' }}>
              {this.state.sessionTimes &&
                this.state.sessionTimes.map((row, idx) => (
                  <Grid key={idx} container justifyContent="center">
                    <table className={classes.tableMob} key={row.name}>
                      <tbody>
                        <tr style={{ backgroundColor: '#fafafa' }}>
                          <td colSpan={2} align="center">
                            <p style={{ color: '#555555', padding: '10px 0', fontWeight: 'bold' }}>
                              {'Session ' + (idx + 1) + ' (' + row[1].startTime + '-' + row[1].endTime + ')'}
                            </p>
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <td
                            align="center"
                            width="40%"
                            style={{
                              padding: '10px 0',
                              backgroundColor: this.props.theme.palette.third.main,
                              color: '#fff',
                              fontWeight: 'bold',
                            }}
                          >
                            <p>입장</p>
                          </td>
                          <td align="center" width="60%">
                            {this.state[row[1].sessionNo + '_IN']}
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <td
                            align="center"
                            width="40%"
                            style={{
                              padding: '10px 0',
                              backgroundColor: this.props.theme.palette.third.main,
                              color: '#fff',
                              fontWeight: 'bold',
                            }}
                          >
                            <p>퇴장</p>
                          </td>
                          <td align="center" width="60%">
                            {this.state[row[1].sessionNo + '_OUT']}
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <td
                            align="center"
                            width="40%"
                            style={{
                              padding: '10px 0',
                              backgroundColor: this.props.theme.palette.third.main,
                              color: '#fff',
                              fontWeight: 'bold',
                            }}
                          >
                            <p>인정시간</p>
                          </td>
                          <td align="center" width="60%">
                            {this.state[row[1].sessionNo + '_TS']}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Grid>
                ))}

              <Grid container justifyContent="center">
                <table className={classes.tableMob}>
                  <tbody>
                    <tr>
                      <td align="center" width="50%" style={{ backgroundColor: '#FAFAFA', color: '#555555', padding: '10px 0' }}>
                        <p>
                          <b>총 인정시간</b>
                        </p>
                      </td>
                      <td align="center" width="50%">
                        <p>{minuteToFormat(this.state.total)}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </div>
            {/*
            {currentPath !== '/live' && this.state.myInfo && this.state.selectIdx === 1 && this.state.myInfo.quiz_1 && ( */}
            {this.state.myInfo && this.state.selectIdx === 1 && this.state.myInfo.quiz_1 && (
              <div style={{ marginBottom: 20, paddingBottom: 20 }}>
                <h2
                  style={
                    this.state.matches
                      ? {
                          color: this.props.theme.palette.primary.main,
                          fontWeight: '900',
                          textAlign: 'center',
                        }
                      : {
                          color: this.props.theme.palette.primary.main,
                          fontWeight: '900',
                        }
                  }
                >
                  Quiz
                </h2>
                <TableContainer style={{ marginTop: 10, marginBottom: 20 }}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell width={'50%'}>문항번호</StyledTableCell>
                        <StyledTableCell width={'50%'}>결과</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.myInfo &&
                        this.state.selectIdx === 1 &&
                        this.state.arrQuiz.map((item, i) => {
                          const my = this.state.myInfo[item.id] >= 0 ? this.state.myInfo[item.id] : -1;
                          const quizResult =
                            Number(item.answer) === Number(my) + 1 ? (
                              <Typography style={{ color: 'green' }}>정답</Typography>
                            ) : (
                              <Typography style={{ color: 'red' }}>오답</Typography>
                            );
                          return (
                            <TableRow key={'sub-row-' + i}>
                              <StyledTableCell style={{ width: '308px' }} key={'header-cell-' + i}>
                                {item.orderNo}
                              </StyledTableCell>
                              <StyledTableCell style={{ textAlign: 'center' }} key={'sub-cell2-' + i}>
                                {quizResult}
                                {/*{`${Number(my) + 1} ( ${item.answer} ) ==> ${quizResult}`}*/}
                              </StyledTableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            )}
          </Container>
        </div>

        <PrizeEventDialog
          open={this.state.openPrizeEventDialog1}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ openPrizeEventDialog1: false });
            }
          }}
          eventTarget={'산학세션을 수강하신 30명'}
          eventImg={`${EVENT_IMG}/event_dialog_img_01.png`}
          eventUrl={this.state.eventUrl1}
        />

        {/* <PrizeEventDialog
          open={this.state.openPrizeEventDialog2}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ openPrizeEventDialog2: false });
            }
          }}
          eventTarget={'5시간 이상 강의를 수강하신 4명'}
          eventImg={`${EVENT_IMG}/event_dialog_img_02.png`}
          eventUrl={this.state.eventUrl2}
        /> */}

        {/* <PrizeEventDialog
          open={this.state.openPrizeEventDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ openPrizeEventDialog3: false });
            }
          }}
          eventTarget={'전체 강의를 수강하신 1명'}
          eventImg={`${EVENT_IMG}/event_dialog_img_03.png`}
          eventUrl={this.state.eventUrl3}
        /> */}
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MyPage);
